<app-navigation content="Hello from external Angular element"></app-navigation>
<app-personal-chat></app-personal-chat>
<main class="page-content">
  <iframe class="my-content" src="https://phichitsakuldes.com/"></iframe>
</main>
<footer class="page-footer">
  <span>© 2025 My Personal App. All rights reserved.</span>
</footer>
